import { takeLatest, put, call, all } from 'redux-saga/effects';
import NewReportTypes from './NewReport.types';
import {
	getAttendanceReport,
	getLeaveReport,
	getSectionWiseAttendanceReport,
	getManagementLeaveReport,
	getDesignationWiseLeaveReport,
	getEmployeeLeaveReport,
	getMonthlyAttendanceSummaryReport,
	getMonthlyCheckoutReport,
	getMonthlyCheckoutDetailsReport,
	getCompOffReport,
	getRefreshmentReport,
	getOnDutyReport,
	getAllEmployeesCheckInOut,
	checkInLockedService,
	checkInLockedHistoryService,
	checkInLockedExcuseService,
	checkInUnLockedHistoryService,
	getFestivalAdvanceReport,
	getAllFestivalNames,
	updateFestivalAdvanceStatus,
	getMedicalAllowanceReport,
	updateMedicalAllowanceStatus,
} from './NewReport.services';
import {
	getAttendanceReportSuccess,
	getAttendanceReportFailure,
	getLeaveReportSuccess,
	getLeaveReportFailure,
	getSectionWiseAttendanceReportSuccess,
	getSectionWiseAttendanceReportFailure,
	getManagementLeaveReportSuccess,
	getManagementLeaveReportFailure,
	getDesignationWiseLeaveReportSuccess,
	getDesignationWiseLeaveReportFailure,
	getEmployeeLeaveReportSuccess,
	getEmployeeLeaveReportFailure,
	getMonthlyAttendanceSummaryReportSuccess,
	getMonthlyAttendanceSummaryReportFailure,
	getMonthlyCheckoutReportSuccess,
	getMonthlyCheckoutReportFailure,
	getMonthlyCheckoutDetailsSuccess,
	getMonthlyCheckoutDetailsFailure,
	getCompOffReportSuccess,
	getCompOffReportFailure,
	getRefreshmentReportSuccess,
	getRefreshmentReportFailure,
	getOnDutyReportSuccess,
	getOnDutyReportFailure,
	getAllEmployeesCheckInOutSuccess,
	getAllEmployeesCheckInOutFailure,
	checkInLockedSuccess,
	checkInLockedFailure,
	checkInLockedHistorySuccess,
	checkInLockedHistoryFailure,
	checkInLockedExcuseSuccess,
	checkInLockedExcuseFailure,
	checkInUnLockedHistorySuccess,
	checkInUnLockedHistoryFailure,
	getFestivalAdvanceReportSuccess,
	getFestivalAdvanceReportFailure,
	getAllFestivalNamesSuccess,
	getAllFestivalNamesFailure,
	updateFestivalAdvanceStatusSuccess,
	updateFestivalAdvanceStatusFailure,
	getMedicalAllowanceReportSuccess,
	getMedicalAllowanceReportFailure,
	updateMedicalAllowanceStatusSuccess,
	updateMedicalAllowanceStatusFailure,
} from './NewReport.actions';
import { encryptData } from '../_common/enode-decode';
import AlertManager from '../../utils/alertManager';

// ========== ATTENDANCE REPORT SAGAS START ==========
export function* getAttendanceReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.GET_ATTENDANCE_REPORT_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getAttendanceReport as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getAttendanceReportSuccess(responseData.data));
			} else {
				yield put(getAttendanceReportFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getAttendanceReportFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

// ========== LEAVE REPORT SAGAS START ==========
export function* getLeaveReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(payload.payload, NewReportTypes.GET_LEAVE_REPORT_KEY);
		// @ts-ignore
		const responseData = yield call(getLeaveReport as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getLeaveReportSuccess(responseData.data));
			} else {
				yield put(getLeaveReportFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(getLeaveReportFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onGetAttendanceReportStart(): Generator<any, void, any> {
	yield takeLatest(NewReportTypes.GET_ATTENDANCE_REPORT_START as any, getAttendanceReportSaga);
}

export function* onGetLeaveReportStart(): Generator<any, void, any> {
	yield takeLatest(NewReportTypes.GET_LEAVE_REPORT_START as any, getLeaveReportSaga);
}

// ========== MANAGEMENT LEAVE REPORT SAGAS START ==========
export function* getManagementLeaveReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.GET_MANAGEMENT_LEAVE_REPORT_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getManagementLeaveReport as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getManagementLeaveReportSuccess(responseData.data));
			} else {
				yield put(getManagementLeaveReportFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getManagementLeaveReportFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onGetManagementLeaveReportStart(): Generator<any, void, any> {
	yield takeLatest(
		NewReportTypes.GET_MANAGEMENT_LEAVE_REPORT_START as any,
		getManagementLeaveReportSaga,
	);
}

// ========== DESIGNATION WISE LEAVE REPORT SAGAS START ==========
export function* getDesignationWiseLeaveReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.GET_DESIGNATION_WISE_LEAVE_REPORT_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getDesignationWiseLeaveReport as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getDesignationWiseLeaveReportSuccess(responseData.data));
			} else {
				yield put(getDesignationWiseLeaveReportFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getDesignationWiseLeaveReportFailure(
				error?.response?.data?.message || 'An error occurred',
			),
		);
	}
}

export function* onGetDesignationWiseLeaveReportStart(): Generator<any, void, any> {
	yield takeLatest(
		NewReportTypes.GET_DESIGNATION_WISE_LEAVE_REPORT_START as any,
		getDesignationWiseLeaveReportSaga,
	);
}
// ========== EMPLOYEE LEAVE REPORT SAGAS START ==========
export function* getEmployeeLeaveReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.GET_EMPLOYEE_LEAVE_REPORT_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getEmployeeLeaveReport as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getEmployeeLeaveReportSuccess(responseData.data));
			} else {
				yield put(getEmployeeLeaveReportFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getEmployeeLeaveReportFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onGetEmployeeLeaveReportStart(): Generator<any, void, any> {
	yield takeLatest(
		NewReportTypes.GET_EMPLOYEE_LEAVE_REPORT_START as any,
		getEmployeeLeaveReportSaga,
	);
}
// ========== MONTHLY ATTENDANCE SUMMARY REPORT SAGAS START ==========
export function* getMonthlyAttendanceSummaryReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getMonthlyAttendanceSummaryReport as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getMonthlyAttendanceSummaryReportSuccess(responseData.data));
			} else {
				yield put(getMonthlyAttendanceSummaryReportFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getMonthlyAttendanceSummaryReportFailure(
				error?.response?.data?.message || 'An error occurred',
			),
		);
	}
}

export function* onGetMonthlyAttendanceSummaryReportStart(): Generator<any, void, any> {
	yield takeLatest(
		NewReportTypes.GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_START as any,
		getMonthlyAttendanceSummaryReportSaga,
	);
}
// ========== MONTHLY CHECKOUT REPORT SAGAS START ==========
export function* getMonthlyCheckoutReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.GET_MONTHLY_CHECKOUT_REPORT_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getMonthlyCheckoutReport as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getMonthlyCheckoutReportSuccess(responseData.data));
			} else {
				yield put(getMonthlyCheckoutReportFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getMonthlyCheckoutReportFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* getMonthlyCheckoutDetailsReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.GET_MONTHLY_CHECKOUT_DETAILS_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getMonthlyCheckoutDetailsReport as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getMonthlyCheckoutDetailsSuccess(responseData.data));
			} else {
				yield put(getMonthlyCheckoutDetailsFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getMonthlyCheckoutDetailsFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onGetMonthlyCheckoutReportStart(): Generator<any, void, any> {
	yield takeLatest(
		NewReportTypes.GET_MONTHLY_CHECKOUT_REPORT_START as any,
		getMonthlyCheckoutReportSaga,
	);
}

export function* onGetMonthlyCheckoutDetailsReportStart(): Generator<any, void, any> {
	yield takeLatest(
		NewReportTypes.GET_MONTHLY_CHECKOUT_DETAILS_START as any,
		getMonthlyCheckoutDetailsReportSaga,
	);
}

// ========== COMP OFF REPORT SAGAS START ==========
export function* getCompOffReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(payload.payload, NewReportTypes.GET_COMPOFF_REPORT_KEY);
		// @ts-ignore
		const responseData = yield call(getCompOffReport as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getCompOffReportSuccess(responseData.data));
			} else {
				yield put(getCompOffReportFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(getCompOffReportFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onGetCompOffReportStart(): Generator<any, void, any> {
	yield takeLatest(NewReportTypes.GET_COMPOFF_REPORT_START as any, getCompOffReportSaga);
}

// ========== REFRESHMENT REPORT SAGAS START ==========
export function* getRefreshmentReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.GET_REFRESHMENT_REPORT_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getRefreshmentReport as any, encryptedData);
		console.log('Refreshment report response:', responseData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getRefreshmentReportSuccess(responseData.data));
			} else {
				yield put(
					getRefreshmentReportFailure(responseData.data?.message || responseData.data),
				);
			}
		}
	} catch (error: any) {
		console.error('Refreshment report error:', error);
		console.error('Error response:', error?.response);
		yield put(
			getRefreshmentReportFailure(
				error?.response?.data?.message || error?.message || 'An error occurred',
			),
		);
	}
}

export function* onGetRefreshmentReportStart(): Generator<any, void, any> {
	yield takeLatest(NewReportTypes.GET_REFRESHMENT_REPORT_START as any, getRefreshmentReportSaga);
}

// ========== ON DUTY REPORT SAGAS START ==========
export function* getOnDutyReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(payload.payload, NewReportTypes.GET_ONDUTY_REPORT_KEY);
		// @ts-ignore
		const responseData = yield call(getOnDutyReport as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		}
		
		if (responseData.data.status === 'success') {
			yield put(getOnDutyReportSuccess(responseData.data));
		} else {
			yield put(getOnDutyReportFailure(responseData.data));
		}
	} catch (error: any) {
		console.error('OnDutyReport saga error:', error);
		yield put(
			getOnDutyReportFailure(error?.response?.data?.message || error?.message || 'An error occurred'),
		);
	}
}

export function* onGetOnDutyReportStart(): Generator<any, void, any> {
	yield takeLatest(NewReportTypes.GET_ONDUTY_REPORT_START as any, getOnDutyReportSaga);
}

// ========== GET ALL EMPLOYEES CHECK-IN/CHECK-OUT SAGAS START ==========
export function* getAllEmployeesCheckInOutSaga(payload: any) {
	try {
		const encryptedData = encryptData(payload.payload, NewReportTypes.GET_ALL_EMPLOYEES_CHECKINOUT_KEY);
		// @ts-ignore
		const responseData = yield call(getAllEmployeesCheckInOut as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		}
		
		if (responseData.data.status === 'success') {
			yield put(getAllEmployeesCheckInOutSuccess(responseData.data));
		} else {
			yield put(getAllEmployeesCheckInOutFailure(responseData.data));
		}
	} catch (error: any) {
		console.error('GetAllEmployeesCheckInOut saga error:', error);
		yield put(
			getAllEmployeesCheckInOutFailure(error?.response?.data?.message || error?.message || 'An error occurred'),
		);
	}
}

export function* onGetAllEmployeesCheckInOutStart(): Generator<any, void, any> {
	yield takeLatest(NewReportTypes.GET_ALL_EMPLOYEES_CHECKINOUT_START as any, getAllEmployeesCheckInOutSaga);
}
// ========== GET ALL EMPLOYEES CHECK-IN/CHECK-OUT SAGAS END ==========

// ========== SECTION WISE ATTENDANCE REPORT SAGAS START ==========
export function* getSectionWiseAttendanceReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.GET_SECTION_WISE_ATTENDANCE_REPORT_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getSectionWiseAttendanceReport as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getSectionWiseAttendanceReportSuccess(responseData.data));
			} else {
				yield put(getSectionWiseAttendanceReportFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getSectionWiseAttendanceReportFailure(
				error?.response?.data?.message || 'An error occurred',
			),
		);
	}
}

export function* onGetSectionWiseAttendanceReportStart(): Generator<any, void, any> {
	yield takeLatest(
		NewReportTypes.GET_SECTION_WISE_ATTENDANCE_REPORT_START as any,
		getSectionWiseAttendanceReportSaga,
	);
}

// ========== CHECK-IN LOCKED SAGAS START ==========
export function* checkInLockedSaga(payload: any) {
	try {
		const encryptedData = encryptData(payload.payload, NewReportTypes.CHECK_IN_LOCKED_KEY);
		// @ts-ignore
		const responseData = yield call(checkInLockedService as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(checkInLockedSuccess(responseData.data));
			} else {
				yield put(checkInLockedFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(checkInLockedFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* checkInLockedHistorySaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.CHECK_IN_LOCKED_HISTORY_KEY,
		);
		// @ts-ignore
		const responseData = yield call(checkInLockedHistoryService as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(checkInLockedHistorySuccess(responseData.data));
			} else {
				yield put(checkInLockedHistoryFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			checkInLockedHistoryFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* checkInLockedExcuseSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.CHECK_IN_LOCKED_EXCUSE_KEY,
		);
		// @ts-ignore
		const responseData = yield call(checkInLockedExcuseService as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(checkInLockedExcuseSuccess(responseData.data));
			} else {
				yield put(checkInLockedExcuseFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			checkInLockedExcuseFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* checkInUnLockedHistorySaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.CHECK_IN_UNLOCKED_HISTORY_KEY,
		);
		// @ts-ignore
		const responseData = yield call(checkInUnLockedHistoryService as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(checkInUnLockedHistorySuccess(responseData.data));
			} else {
				yield put(checkInUnLockedHistoryFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			checkInUnLockedHistoryFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onCheckInLockedStart(): Generator<any, void, any> {
	yield takeLatest(NewReportTypes.CHECK_IN_LOCKED_START as any, checkInLockedSaga);
}

export function* onCheckInLockedHistoryStart(): Generator<any, void, any> {
	yield takeLatest(NewReportTypes.CHECK_IN_LOCKED_HISTORY_START as any, checkInLockedHistorySaga);
}

export function* onCheckInLockedExcuseStart(): Generator<any, void, any> {
	yield takeLatest(NewReportTypes.CHECK_IN_LOCKED_EXCUSE_START as any, checkInLockedExcuseSaga);
}

export function* onCheckInUnLockedHistoryStart(): Generator<any, void, any> {
	yield takeLatest(
		NewReportTypes.CHECK_IN_UNLOCKED_HISTORY_START as any,
		checkInUnLockedHistorySaga,
	);
}
// ========== CHECK-IN LOCKED SAGAS END ==========

// ========== FESTIVAL ADVANCE REPORT SAGAS START ==========
export function* getFestivalAdvanceReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.GET_FESTIVAL_ADVANCE_REPORT_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getFestivalAdvanceReport as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getFestivalAdvanceReportSuccess(responseData.data));
			} else {
				yield put(getFestivalAdvanceReportFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getFestivalAdvanceReportFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onGetFestivalAdvanceReportStart(): Generator<any, void, any> {
	yield takeLatest(
		NewReportTypes.GET_FESTIVAL_ADVANCE_REPORT_START as any,
		getFestivalAdvanceReportSaga,
	);
}

export function* getAllFestivalNamesSaga(payload: any) {
	try {
		// GetAllFestivalNames doesn't require encrypted data - it returns plain JSON
		// Just send empty/dummy data since backend ignores it
		const dummyData = '';
		// @ts-ignore
		const responseData = yield call(getAllFestivalNames as any, dummyData);
		console.log('🔍 getAllFestivalNames API Response:', responseData);
		
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getAllFestivalNamesSuccess(responseData.data));
			} else {

				yield put(getAllFestivalNamesFailure(responseData.data));
			}
		}
	} catch (error: any) {
		console.error('❌ Error fetching festival names:', error);
		yield put(
			getAllFestivalNamesFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onGetAllFestivalNamesStart(): Generator<any, void, any> {
	yield takeLatest(
		NewReportTypes.GET_ALL_FESTIVAL_NAMES_START as any,
		getAllFestivalNamesSaga,
	);
}

export function* updateFestivalAdvanceStatusSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.UPDATE_FESTIVAL_ADVANCE_STATUS_KEY,
		);
		// @ts-ignore
		const responseData = yield call(updateFestivalAdvanceStatus as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			// Check if response has encrypted data structure (has response field) or plain error
			if (responseData.data.status === 'success' && responseData.data.response) {
				// Success with encrypted response
				yield put(updateFestivalAdvanceStatusSuccess(responseData.data));
			} else if (responseData.data.status === 'error' && responseData.data.response) {
				// Error with encrypted response
				yield put(updateFestivalAdvanceStatusSuccess(responseData.data));
			} else if (responseData.data.status === 'error') {
				// Plain error response (not encrypted)
				yield put(updateFestivalAdvanceStatusFailure(responseData.data));
			} else {
				// Unknown response structure, try to handle as encrypted if response field exists
				if (responseData.data.response) {
					yield put(updateFestivalAdvanceStatusSuccess(responseData.data));
				} else {
					yield put(updateFestivalAdvanceStatusFailure(responseData.data || { status: 'error', message: 'Unknown response structure' }));
				}
			}
		}
	} catch (error: any) {
		yield put(
			updateFestivalAdvanceStatusFailure(error?.response?.data || { status: 'error', message: 'An error occurred' }),
		);
	}
}

export function* onUpdateFestivalAdvanceStatusStart(): Generator<any, void, any> {
	yield takeLatest(
		NewReportTypes.UPDATE_FESTIVAL_ADVANCE_STATUS_START as any,
		updateFestivalAdvanceStatusSaga,
	);
}
// ========== FESTIVAL ADVANCE REPORT SAGAS END ==========

// ========== MEDICAL ALLOWANCE REPORT SAGAS START ==========
export function* getMedicalAllowanceReportSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.GET_MEDICAL_ALLOWANCE_REPORT_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getMedicalAllowanceReport as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getMedicalAllowanceReportSuccess(responseData.data));
			} else {
				yield put(getMedicalAllowanceReportFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getMedicalAllowanceReportFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onGetMedicalAllowanceReportStart(): Generator<any, void, any> {
	yield takeLatest(
		NewReportTypes.GET_MEDICAL_ALLOWANCE_REPORT_START as any,
		getMedicalAllowanceReportSaga,
	);
}

export function* updateMedicalAllowanceStatusSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			NewReportTypes.UPDATE_MEDICAL_ALLOWANCE_STATUS_KEY,
		);
		// @ts-ignore
		const responseData = yield call(updateMedicalAllowanceStatus as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			// Check if response has encrypted data structure (has response field) or plain error
			if (responseData.data.status === 'success' && responseData.data.response) {
				// Success with encrypted response
				yield put(updateMedicalAllowanceStatusSuccess(responseData.data));
			} else if (responseData.data.status === 'error' && responseData.data.response) {
				// Error with encrypted response
				yield put(updateMedicalAllowanceStatusSuccess(responseData.data));
			} else if (responseData.data.status === 'error') {
				// Plain error response (not encrypted)
				yield put(updateMedicalAllowanceStatusFailure(responseData.data));
			} else {
				// Unknown response structure, try to handle as encrypted if response field exists
				if (responseData.data.response) {
					yield put(updateMedicalAllowanceStatusSuccess(responseData.data));
				} else {
					yield put(updateMedicalAllowanceStatusFailure(responseData.data || { status: 'error', message: 'Unknown response structure' }));
				}
			}
		}
	} catch (error: any) {
		yield put(
			updateMedicalAllowanceStatusFailure(error?.response?.data || { status: 'error', message: 'An error occurred' }),
		);
	}
}

export function* onUpdateMedicalAllowanceStatusStart(): Generator<any, void, any> {
	yield takeLatest(
		NewReportTypes.UPDATE_MEDICAL_ALLOWANCE_STATUS_START as any,
		updateMedicalAllowanceStatusSaga,
	);
}
// ========== MEDICAL ALLOWANCE REPORT SAGAS END ==========

export function* newReportSagaDetails() {
	yield all([
		call(onGetAttendanceReportStart),
		call(onGetLeaveReportStart),
		call(onGetDesignationWiseLeaveReportStart),
		call(onGetEmployeeLeaveReportStart),
		call(onGetManagementLeaveReportStart),
		call(onGetMonthlyAttendanceSummaryReportStart),
		call(onGetMonthlyCheckoutReportStart),
		call(onGetMonthlyCheckoutDetailsReportStart),
		call(onGetCompOffReportStart),
		call(onGetRefreshmentReportStart),
		call(onGetOnDutyReportStart),
		call(onGetAllEmployeesCheckInOutStart),
		call(onGetSectionWiseAttendanceReportStart),
		call(onCheckInLockedStart),
		call(onCheckInLockedHistoryStart),
		call(onCheckInLockedExcuseStart),
		call(onCheckInUnLockedHistoryStart),
		call(onGetFestivalAdvanceReportStart),
		call(onGetAllFestivalNamesStart),
		call(onUpdateFestivalAdvanceStatusStart),
		call(onGetMedicalAllowanceReportStart),
		call(onUpdateMedicalAllowanceStatusStart),
	]);
}
